import { ApiClient } from '@/lib/axios/client';
import type { LinkCustomMetabaseReportRequest, MetabaseReport, MetabaseReportListing, RefreshMetabaseReportsResponse } from './types';

const basePath = (orgId: string) => `/api/v1/orgs/${orgId}/metabase-reports`;

export class MetabaseReportApi {
  static async list(orgId: string): Promise<MetabaseReportListing> {
    return await ApiClient.get<MetabaseReportListing>(basePath(orgId));
  }

  static async refresh(orgId: string, keys: string[]): Promise<RefreshMetabaseReportsResponse> {
    return await ApiClient.post<RefreshMetabaseReportsResponse>(`${basePath(orgId)}/refresh`, { keys });
  }

  static async linkCustom(orgId: string, request: LinkCustomMetabaseReportRequest): Promise<MetabaseReport> {
    return await ApiClient.post<MetabaseReport>(`${basePath(orgId)}/custom`, request);
  }

  static async unlinkCustom(orgId: string, key: string): Promise<void> {
    return await ApiClient.delete(`${basePath(orgId)}/custom/${encodeURIComponent(key)}`);
  }
}
